var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragRejected = function SvgDragRejected(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 94,
    viewBox: "0 0 73 94",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M71.594 20.697C72.37 21.48 73 23.012 73 24.12v59.829C73 89.5 68.523 94 63.003 94H9.997C4.476 94 0 89.498 0 83.951V10.05C0 4.499 4.475 0 9.995 0h39.05c1.109 0 2.641.638 3.414 1.417l19.135 19.28z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DB524B",
    strokeWidth: 3,
    d: "M70.529 21.754c.497.501.971 1.654.971 2.365v59.829c0 4.724-3.807 8.552-8.497 8.552H9.997c-4.69 0-8.497-3.828-8.497-8.549V10.05C1.5 5.325 5.305 1.5 9.995 1.5h39.05c.708 0 1.857.477 2.35.974l19.134 19.28z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#DB524B",
    strokeWidth: 3,
    d: "M71.293 22.293c.39.39.268.707-.295.707H60.002C54.478 23 50 18.521 50 12.998V2.002c0-.553.311-.691.707-.295l20.586 20.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB524B",
    d: "M37 42.374l-6.616-6.616a2.57 2.57 0 0 0-3.632-.006 2.562 2.562 0 0 0 .006 3.632L33.374 46l-6.616 6.616a2.57 2.57 0 0 0-.006 3.632 2.562 2.562 0 0 0 3.632-.006L37 49.626l6.616 6.616a2.57 2.57 0 0 0 3.632.006 2.562 2.562 0 0 0-.006-3.632L40.626 46l6.616-6.616a2.57 2.57 0 0 0 .006-3.632 2.562 2.562 0 0 0-3.632.006L37 42.374z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragRejected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag-rejected.46d6c4eca97ab9a9d2ada39a250af969.svg";